import React, { useState } from 'react';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CountdownTimer from './components/CountdownTimer';
import LocationMap from './components/LocationMap';
// import WeddingWeatherWidget from './components/WeddingWeatherWidget';
import RSVPForm from './components/RSVPForm';
import InfoSection from './components/InfoSection';
import Footer from './components/Footer';
import ImageOverlay from './components/ImageOverlay';
import CardFlipIntro from './components/CardFlipIntro';
import GuestGate from './components/GuestGate';
import BenceIntro from './components/BenceIntro';

import CoupleSection from './components/CoupleSection';
import Suggestions from './components/Suggestions';
import SteamAchievement from './components/SteamAchievement';
import GuestPairingAdmin from './components/GuestPairingAdmin';
import { OverlayProvider, useOverlay } from './context/OverlayContext';
import { LanguageProvider } from './context/LanguageContext';
import { GuestProvider, useGuest } from './context/GuestContext';
import './styles/Global.css';
import './styles/App.css';
import './styles/RSVPForm.css';

function AppContent() {
  const { overlayData, closeOverlay } = useOverlay();
  const { guest, logout } = useGuest();
  const [showIntro, setShowIntro] = useState(!guest);
  const [showGate, setShowGate] = useState(false);
  const [showBenceIntro, setShowBenceIntro] = useState(false);
  const [showPairingAdmin, setShowPairingAdmin] = useState(false);
  const isAdmin = guest?.special === 'amiker' || guest?.special === 'gergely';

  const handleLogout = () => {
    logout();
    setShowIntro(true);
    setShowGate(false);
  };

  const handleIntroComplete = () => {
    setShowIntro(false);
    setShowGate(true);
  };

  const handleAuthenticated = (foundGuest) => {
    setShowGate(false);
    if (foundGuest?.special === 'bence') {
      setShowBenceIntro(true);
    }
  };

  const mainContent = !showIntro && !showGate && !showBenceIntro;

  return (
    <div className="App">
      {showIntro && <CardFlipIntro onComplete={handleIntroComplete} />}
      {showGate && (
        <GuestGate onAuthenticated={handleAuthenticated} />
      )}
      {showBenceIntro && (
        <BenceIntro onComplete={() => setShowBenceIntro(false)} />
      )}

      {mainContent && (
        <>
          <Navbar onLogout={handleLogout} />

          <Hero />
            <LocationMap />
            <Suggestions />
            <CoupleSection />
            {/* <WeddingWeatherWidget /> */}
            <RSVPForm />
            <InfoSection />
            <CountdownTimer />
            <Footer />

            <ImageOverlay
              isOpen={overlayData.isOpen}
              imageName={overlayData.imageName}
              onClose={closeOverlay}
            />

            {isAdmin && (
              <button
                className="pairing-admin-btn"
                onClick={() => setShowPairingAdmin(true)}
                title="Manage guest pairings"
              >
                Pair Guests
              </button>
            )}
            {showPairingAdmin && (
              <GuestPairingAdmin onClose={() => setShowPairingAdmin(false)} />
            )}

            {guest?.special === 'amiker' && <SteamAchievement title="Said Yes To The Dress (And The Man)" />}
            {guest?.special === 'gergely' && <SteamAchievement title="She Actually Said Yes" />}
            {guest?.special === 'boldizsar' && <SteamAchievement title="First Social Event" />}
            {guest?.special === 'ambrus' && <SteamAchievement title="Will Leave The House" />}
            {guest?.special === 'endre' && <SteamAchievement title="Second Strongest Punch In Town AKA Az Ördög Bal Keze" />}
            {guest?.special === 'david' && <SteamAchievement title="Found A Wedding That Serves Tubi" />}
            {guest?.special === 'bence' && <SteamAchievement title="Oooooooweeeeeeeee" />}
            {guest?.special === 'joco' && <SteamAchievement title="Escaped The Workshop" />}
            {guest?.special === 'gyula' && <SteamAchievement title="Didn't Fall Asleep During Ceremony" />}
        </>
      )}
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <GuestProvider>
        <OverlayProvider>
          <AppContent />
        </OverlayProvider>
      </GuestProvider>
    </LanguageProvider>
  );
}

export default App;
